module.exports = __webpack_public_path__ + "media/04.cc9ae41a.mp3";